import { render, staticRenderFns } from "./settingMagnet.vue?vue&type=template&id=17f084de&scoped=true&"
import script from "./settingMagnet.vue?vue&type=script&lang=js&"
export * from "./settingMagnet.vue?vue&type=script&lang=js&"
import style0 from "./settingMagnet.vue?vue&type=style&index=0&id=17f084de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f084de",
  null
  
)

export default component.exports